import { Node } from './node';
import { HEIGHT_WORKSPACE_ITEM, NodeModelTypes } from '../utils/consts';
import { NodeModel } from './types';
import type { Tree } from './tree';
import { DiffMode } from '@ardoq/api-types';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';

class ScenarioNode extends Node {
  private _id: string;
  private _children: NodeModel[] = [];
  private _workspaceChildrenIds: string[];

  constructor(tree: Tree, id: string, childrenIds: string[]) {
    super(tree, null);
    this._id = id;
    this._workspaceChildrenIds = childrenIds;
    this.updateChildren();
  }

  override get id() {
    return this._id;
  }

  override get hasWriteAccess() {
    return true;
  }

  override get type() {
    return NodeModelTypes.SCENARIO;
  }

  override isFlexibleModel() {
    return false;
  }

  getChildren() {
    return this._children;
  }

  override getItemHeight() {
    return HEIGHT_WORKSPACE_ITEM;
  }

  override getWorkspaceId() {
    return '';
  }

  override getOrder() {
    return 0;
  }

  hasChildren() {
    return Boolean(this._workspaceChildrenIds.length);
  }

  updateChildren() {
    const tree = this.tree;
    if (tree === null) return;
    this._children = this._workspaceChildrenIds.map(workspaceId =>
      tree.getOrCreateNode(tree, workspaceId, this)
    );
  }

  override getName(i18nLocale: I18nLocale = DEFAULT_ARDOQ_I18NLOCALE) {
    const { isInDiffMode, getDiffMode, getScenarioName } =
      this.tree.navigatorViewInterface;
    if (isInDiffMode()) {
      switch (getDiffMode()) {
        case DiffMode.MAIN:
          return t(
            i18nLocale,
            'componentHierarchies:scenarioNode.mainline',
            'Mainline'
          );

        case DiffMode.DIFF:
          return t(
            i18nLocale,
            'componentHierarchies:scenarioNode.diff',
            'Diff'
          );
      }
    }

    return getScenarioName(this.id) ?? '';
  }
}

export { ScenarioNode };
